import EventHandlerFactory from "./event_handler/factory.js";
import WindowFactory from "./window/factory.js";

export default class Factory {
    static make() {
        return new this();
    }
    eventHandler() {
        return new EventHandlerFactory(this);
    }
    window() {
        return new WindowFactory(this);
    }
}
